<template>
  <page :title="i18n.title">
    <!-- <div id="paypal-button"></div>
    <div class="confirm-warp">
      <div class="confirm-info">
        <div class="confirm-title">{{i18n.pay_label}}</div>
        <div class="confirm-price">{{currencyName}}{{payMode === 'creditcard' ? cabinet.yajin : price}}</div>
      </div>
    </div> -->
    <div id="dropin-container"></div>
    <div class="confirm-btns">
      <div v-show="isSubmit" id="submit-button" class="btn">{{i18n.msg_fail_confirm}}</div>
    </div>
  </page>
</template>

<script>
import { CLIENT_TOKEN, PAYMENT_PREAUTH } from '../../apis/payment'
import dropin from 'braintree-web-drop-in'
export default {
  computed: {
    i18n () {
      return this.$t('confirm')
    }
  },
  data () {
    return {
      price: 0,
      payType: 'YJ',
      payMode: 'paypal',
      qrcode: '',
      priceId: '',
      outTradeNo: '',
      isSubmit: false
    }
  },
  methods: {
    getClientToken () {
      const vm = this
      var button = document.querySelector('#submit-button')
      this.$loading(true)
      this.$post(
        CLIENT_TOKEN,
        {},
        resp => {
          if (resp.clientToken) {
            dropin.create({
              authorization: resp.clientToken,
              container: '#dropin-container',
              vaultManager: true,
              paypal: {
                flow: 'vault'
              },
              venmo: {
                allowNewBrowserTab: false
              }
            }, function (createErr, instance) {
              vm.$loading(false)
              vm.isSubmit = true
              button.addEventListener('click', function () {
                instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
                  // Submit payload.nonce to your server
                  console.log('requestPaymentMethodErr', requestPaymentMethodErr)
                  console.log('payload', payload)
                  if (requestPaymentMethodErr) {
                    vm.$toast(requestPaymentMethodErr)
                  } else if (vm.qrcode) {
                    vm.onPreauth(payload.nonce)
                  }
                })
              })
            })
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    onPreauth (nonce) {
      this.$loading(true)
      this.$post(
        `${PAYMENT_PREAUTH}/${this.qrcode}`,
        {
          paymentMethodNonce: nonce,
          deviceData: ''
        },
        resp => {
          this.$loading(false)
          this.$router.push(`/result?tradeNo=${resp.data.outTradeNo}`)
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    }
  },
  created () {
    this.qrcode = this.$route.query.qrcode
  },
  mounted () {
    this.getClientToken()
  }
}
</script>

<style lang="less">
.confirm-warp {
  overflow-y: scroll;
}
.confirm-info {
  background: #ffffff;
  text-align: center;
  padding: 40px;
}
.confirm-title {
  font-size: 36px;
}
.confirm-price {
  font-size: 80px;
  color: #fc0d1b;
}
.confirm-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }
  & span {
    text-align: left;
    font-size: 28px;
    color: #999999;
  }
}
.confirm-payment {
  background: #ffffff;
  padding: 30px;
  &-label {
    padding: 10px 20px;
    font-size: 28px;
    color: #999999;
  }
  &-item {
    display: flex;
    align-items: center;
    padding: 30px 20px;
    border-bottom: 1px solid #dddddd;
    & img {
      width: 40px;
      height: 40px;
    }
    &-info {
      display: flex;
      align-items: center;
      flex: 1;
      & .content {
        padding-left: 10px;
      }
      & .sub_title {
        font-size: 28px;
        color: #fec348;
      }
    }
  }
}
.confirm-remark {
  padding: 0 32px;
}
.confirm-remark .title {
  margin-top: 40px;
  font-size: 32px;
}
.confirm-remark .desc {
  font-size: 28px;
  color: rgba(102, 102, 102, 1);
  font-weight: 400;
  word-break: normal !important;
  white-space: normal !important;
}
.confirm-btns {
  padding: 60px 40px 20px;
}
.confirm-btns .btn {
  margin-top: 20px;
}
/* #ifdef MP-WEIXIN */
.confirm-btns button.btn {
  background-color: #65b74e;
}
/* #endif */
.confirm-checkbox {
  padding: 30px;
  & label {
    display: flex;
    align-items: center;
  }
  & span {
    color: #52ac7a;
  }
}
.btn-paypal {
  background: #fec348 !important;
}
.btn-paypal img {
  width: 277px;
  height: 60px;
  margin: 18px 0;
}
.btn-applepay {
  background: #ffffff !important;
  color: #050608;
}
.btn-applepay img {
  width: 143px;
  height: 60px;
  margin: 18px 0;
}
.btn-googlepay {
  color: #5f6368;
  background: #ffffff !important;
}
.btn-googlepay img {
  width: 145px;
  height: 60px;
  margin: 18px 0;
}
.creditcard-input {
  margin: 48px 48px 200px;
  padding: 20px;
  border-radius: 20px;
  border: 1Px solid #E4E7ED;
}
.creditcard-btn {
  margin: 48px;
}
</style>
